// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.world-map-container {
  position: relative;
}
.world-map-container .tooltip-component {
  border: 1px solid var(--gray_light2);
  background: var(--base_color2);
  border-radius: 5px;
  box-shadow: 2px 2px 6px -4px var(--gray);
  cursor: default;
  font-size: 14px;
  pointer-events: none;
  position: absolute;
  overflow: hidden;
  white-space: nowrap;
  z-index: 10;
  transition: 0.15s ease all;
  transform: translate(-50px, -100%);
}
.world-map-container .tooltip-component .tooltip-title {
  padding: 6px;
  font-size: 15px;
  margin-bottom: 4px;
  background: var(--gray_light2);
  border-bottom: 1px solid var(--gray_light1);
}
.world-map-container .tooltip-component .tooltip-series-group {
  padding: 0 6px;
  text-align: left;
  justify-content: left;
  align-items: center;
}
.world-map-container .tooltip-component .tooltip-series-group:last-child {
  padding-bottom: 4px;
}
.world-map-container .tooltip-component .tooltip-series-group .tooltip-data-title {
  text-transform: capitalize;
}
.world-map-container .tooltip-component .tooltip-series-group .tooltip-title,
.world-map-container .tooltip-component .tooltip-series-group .tooltip-value {
  font-weight: 600;
}
.world-map-container .world-map {
  position: relative;
  width: 630px;
}
.world-map-container .world-map .zoom-button {
  position: absolute;
  bottom: 10px;
  right: 10px;
  background-color: var(--color_primary_500);
  fill: var(--base_color2);
  width: 20px;
  height: 20px;
  border-radius: 10px;
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.world-map-container .world-map .zoom-button .zoom-icon {
  height: 16px;
  width: 16px;
  fill: white;
}
.world-map-container .world-map .zoom-button .zoom-icon path[stroke] {
  stroke: white;
}
.world-map-container .world-map .zoom-button:hover {
  background-color: var(--primary_dark1);
}
.world-map-container .world-map .zoom-button.zoom-in {
  transform: translateY(-30px);
}
.world-map-container .world-map .country {
  transition: 0.1s ease-out fill;
}`, "",{"version":3,"sources":["webpack://./src/components/WorldMap/index.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;AACE;EACE,oCAAA;EACA,8BAAA;EACA,kBAAA;EACA,wCAAA;EACA,eAAA;EACA,eAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,0BAAA;EACA,kCAAA;AACJ;AACI;EACE,YAAA;EACA,eAAA;EACA,kBAAA;EACA,8BAAA;EACA,2CAAA;AACN;AAEI;EACE,cAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBAAA;AAAN;AAEM;EACE,mBAAA;AAAR;AAGM;EACE,0BAAA;AADR;AAIM;;EAEE,gBAAA;AAFR;AAOE;EACE,kBAAA;EACA,YAAA;AALJ;AAOI;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,0CAAA;EACA,wBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AALN;AAOM;EACE,YAAA;EACA,WAAA;EACA,WAAA;AALR;AAMQ;EACE,aAAA;AAJV;AAQM;EACE,sCAAA;AANR;AASM;EACE,4BAAA;AAPR;AAWI;EACE,8BAAA;AATN","sourcesContent":[".world-map-container {\n  position: relative;\n\n  .tooltip-component {\n    border: 1px solid var(--gray_light2);\n    background: var(--base_color2);\n    border-radius: 5px;\n    box-shadow: 2px 2px 6px -4px var(--gray);\n    cursor: default;\n    font-size: 14px;\n    pointer-events: none;\n    position: absolute;\n    overflow: hidden;\n    white-space: nowrap;\n    z-index: 10;\n    transition: 0.15s ease all;\n    transform: translate(-50px, -100%);\n\n    .tooltip-title {\n      padding: 6px;\n      font-size: 15px;\n      margin-bottom: 4px;\n      background: var(--gray_light2);\n      border-bottom: 1px solid var(--gray_light1);\n    }\n\n    .tooltip-series-group {\n      padding: 0 6px;\n      text-align: left;\n      justify-content: left;\n      align-items: center;\n\n      &:last-child {\n        padding-bottom: 4px;\n      }\n\n      .tooltip-data-title {\n        text-transform: capitalize;\n      }\n\n      .tooltip-title,\n      .tooltip-value {\n        font-weight: 600;\n      }\n    }\n  }\n\n  .world-map {\n    position: relative;\n    width: 630px;\n\n    .zoom-button {\n      position: absolute;\n      bottom: 10px;\n      right: 10px;\n      background-color: var(--color_primary_500);\n      fill: var(--base_color2);\n      width: 20px;\n      height: 20px;\n      border-radius: 10px;\n      padding: 0;\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n\n      .zoom-icon {\n        height: 16px;\n        width: 16px;\n        fill: white;\n        path[stroke] {\n          stroke: white;\n        }\n      }\n\n      &:hover {\n        background-color: var(--primary_dark1);\n      }\n\n      &.zoom-in {\n        transform: translateY(-30px);\n      }\n    }\n\n    .country {\n      transition: 0.1s ease-out fill;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
